import { useEffect, useState } from 'react';

const loadingTexts = {
  pt: 'Carregando...',
  en: 'Loading...',
  es: 'Cargando...',
};

export const LoadingScreen = () => {
  const [loadingText, setLoadingText] = useState('...');

  useEffect(() => {
    // Detect language from URL or localStorage
    const path = window.location.pathname;
    let detectedLang = 'pt'; // default

    if (path.startsWith('/en')) {
      detectedLang = 'en';
    } else if (path.startsWith('/es')) {
      detectedLang = 'es';
    } else {
      // Try to get from localStorage (where i18n stores it)
      const storedLang = localStorage.getItem('i18nextLng');
      if (storedLang && ['pt', 'en', 'es'].includes(storedLang)) {
        detectedLang = storedLang;
      }
    }

    setLoadingText(loadingTexts[detectedLang as keyof typeof loadingTexts]);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <span className="text-lg">{loadingText}</span>
    </div>
  );
};
